"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var FilterSelector_1 = require("Dashboard/FilterSelector/FilterSelector");
var SavedBlockFilterViewStore_1 = require("../SavedBlockFilterViewStore");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var BASE_CLASS_NAME = "saved-block-filter";
var SavedBlockFilterPanel = function (_a) {
    var savedBlockFilterViewStore = _a.savedBlockFilterViewStore, onToggleBlockType = _a.onToggleBlockType;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        savedBlockFilterViewStore.areAnyFiltersSelectedOnOpen && (react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small, width: "full", onClick: savedBlockFilterViewStore.clearAllFilters }, "Clear all filters")),
        react_1.default.createElement(FilterSelector_1.FilterHeader, { text: "Block type" }),
        react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__checkboxes") }, SavedBlockFilterViewStore_1.blockTypeFilterList.map(function (filter) {
            return (react_1.default.createElement(FilterSelector_1.CheckboxFilterRow, { key: filter.type, text: filter.label, checked: savedBlockFilterViewStore.isBlockTypeSelected(filter.type), onChange: function () { return onToggleBlockType(filter.type); } }));
        })),
        react_1.default.createElement(FilterSelector_1.FilterHeader, { text: "Editing permissions" }),
        react_1.default.createElement(kaleidoscope_2.RadioButtonGroup, { selectedId: savedBlockFilterViewStore.editingLockedToAdminFilter, onClickHandler: savedBlockFilterViewStore.setEditingLockedToAdminFilter, options: [
                {
                    id: SavedBlockFilterViewStore_1.EditingLockedToAdminFilter.ShowAllBlocks,
                    label: "Show all blocks",
                },
                {
                    id: SavedBlockFilterViewStore_1.EditingLockedToAdminFilter.EditableByAdminsOnly,
                    label: "Editable by admins only",
                },
                {
                    id: SavedBlockFilterViewStore_1.EditingLockedToAdminFilter.EditableByEveryone,
                    label: "Editable by everyone",
                },
            ] })));
};
exports.default = (0, mobx_react_1.observer)(SavedBlockFilterPanel);
